<template>
  <v-list-item
    :disabled="disabled"
    :active="item.active"
    :to="item.to"
    :value="item.label"
    :exact="item.toExact ?? true"
    rounded
    :base-color="item.color"
    :lines="Array.isArray(item.subtitle) ? 'two' : false"
    :class="item.loading ? 'pulse' : ''"
    :prepend-icon="item.icon"
    v-on="item.onClick ? { click: item.onClick } : {}"
  >
    <v-fade-transition>
      <div>
        <!-- Title -->
        <v-list-item-title>
          {{ item.label }}
        </v-list-item-title>

        <!-- Subtitle -->
        <v-list-item-subtitle v-if="item.subtitle">
          <!-- multi-line-->
          <template v-if="Array.isArray(item.subtitle)">
            <template v-for="sub in item.subtitle" :key="sub"> {{ sub }}<br /> </template>
          </template>
          <!-- single-line -->
          <template v-else> {{ item.subtitle }} </template>
        </v-list-item-subtitle>
      </div>
    </v-fade-transition>

    <template #append>
      <HotkeyKbd
        v-if="item.hotkey && (item.onClick || item.to)"
        class="ps-2"
        :hotkey="typeof item.hotkey === 'string' ? item.hotkey : item.hotkey.key"
        :modifier="typeof item.hotkey === 'string' ? undefined : item.hotkey.modifier"
        :disabled="disabled"
        @pressed="handleHotkeyPress"
      ></HotkeyKbd>
    </template>
  </v-list-item>
</template>

<script lang="ts">
import { defineComponent } from 'vue'
import type { PropType } from 'vue'
import { navigateTo } from 'nuxt/app'
import type { MenuItem } from '~/lib/list-items'
import HotkeyKbd from '~/components/Common/HotkeyKbd.vue'

export default defineComponent({
  name: 'MenuItemsListItem',
  components: { HotkeyKbd },
  props: {
    item: {
      type: Object as PropType<MenuItem>,
      required: true,
    },
  },
  setup(props) {
    return {}
  },
  data() {
    return {}
  },
  computed: {
    disabled() {
      return this.item.disabled || this.item.disabledFn?.() || this.item.loading
    },
  },
  methods: {
    async handleHotkeyPress(ev: KeyboardEvent) {
      if (this.disabled) {
        return
      }
      if (this.item.onClick) {
        this.item.onClick(ev)
        return
      }
      if (this.item.to) {
        await navigateTo(this.item.to)
      }
    },
  },
})
</script>

<style scoped lang="scss">
@keyframes pulse {
  0% {
    opacity: 0.8;
  }
  50% {
    opacity: 0.3;
  }
  100% {
    opacity: 0.8;
  }
}
.pulse {
  animation: pulse 0.9s infinite ease-in-out;
}
</style>
